import { IdentifierType } from '../enums/identifier-type';

export class TaskAttributes {
  public unifiedConversationId?: string;
  public userSessionId?: string;
  public conversationId?: string;
  public primaryCode?: string;
  public secondaryCode?: string;
  public tags?: string[];
}

export class OutboundCallAttributes {
  public teamId: string;
  public callerIdentifier: CallerIdentifier;
}

export class CallerIdentifier {
  public constructor(
    public id: string,
    public type: IdentifierType,
    public displayName?: string,
  ) {}
}
